'use client'

import React, { useEffect, useRef } from 'react'

import RichText from '@/components/RichText'

import type { EmbedBlock as EmbedBlockProps } from '@/payload-types'

type Props = EmbedBlockProps & {
  className?: string
}

export const EmbedBlock: React.FC<Props> = ({
  embedCode,
  className,
  layout = 'stacked',
  sidebarRichText,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!containerRef.current || typeof window === 'undefined') return

    const scriptNodes = containerRef.current.querySelectorAll('script')

    scriptNodes.forEach((script) => {
      const replacement = document.createElement('script')

      Array.from(script.attributes).forEach(({ name, value }) => {
        replacement.setAttribute(name, value)
      })

      if ((replacement as HTMLScriptElement).src) {
        ;(replacement as HTMLScriptElement).async = false
      }

      replacement.textContent = script.textContent

      script.replaceWith(replacement)
    })
  }, [embedCode])

  if (!embedCode) return null

  const wrapperClassName = ['container py-16', className].filter(Boolean).join(' ')

  if (layout === 'split') {
    return (
      <div className={wrapperClassName}>
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] items-start">
          {sidebarRichText ? (
            <div>
              <RichText data={sidebarRichText} enableGutter={false} />
            </div>
          ) : null}

          <div
            className="w-full"
            ref={containerRef}
            dangerouslySetInnerHTML={{ __html: embedCode }}
          />
        </div>
      </div>
    )
  }

  return (
    <div className='bg-white'>
      <div className={wrapperClassName}>
        <div
          className="w-full"
          ref={containerRef}
          dangerouslySetInnerHTML={{ __html: embedCode }}
        />
      </div>
    </div>
  )
}